<div class="cm-node-flex-container">
    @if ($conditionalAmountNode()?.parameters; as parameters) {
        <div class="cm-node-icon" matTooltip="Conditional Amount" matTooltipPosition="above">
            <i class="fa-solid fa-hashtag"></i>
        </div>
        <span class="cm-node-text">{{ $description() }}</span>
        <div class="cm-tools-right">
            @if ($variantConditionNode(); as condition) {
                <cm-variant-condition [variantConditionNode]="condition" (conditionRemoved)="conditionRemoved.emit()"></cm-variant-condition>
            }
            <input name="amount" class="cm-input-width-limit" type="number" min="0" [(ngModel)]="parameters.amount" />
        </div>
    }
</div>
